import { render, staticRenderFns } from "./AssessmentGroupBandEditor.vue?vue&type=template&id=7d836c96&scoped=true"
import script from "./AssessmentGroupBandEditor.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupBandEditor.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupBandEditor.vue?vue&type=style&index=0&id=7d836c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d836c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VSpacer,VTextField})
